import { render, staticRenderFns } from "./MsTextarea.vue?vue&type=template&id=17558e98&scoped=true"
import script from "./MsTextarea.vue?vue&type=script&lang=js"
export * from "./MsTextarea.vue?vue&type=script&lang=js"
import style0 from "./MsTextarea.vue?vue&type=style&index=0&id=17558e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17558e98",
  null
  
)

export default component.exports